import React, {useState} from 'react';
import {Button, Form} from 'react-bootstrap';
import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';

/**
 * Tela cheia de verificação MFA — exibida pelo AuthGuard após login
 * quando o usuário tem 2FA ativo e o dispositivo não é confiável.
 *
 * Props:
 *   userId      {string|number}  ID do usuário (de sessStorage[3])
 *   email       {string}         e-mail do usuário (de sessStorage[6])
 *   fingerprint {string}         fingerprint do dispositivo (base64)
 *   tempToken   {string|null}    token temporário do pending_auth no banco
 *   onSuccess   {function}       chamada após validação bem-sucedida
 */
const MfaChallenge = ({userId, email, fingerprint, tempToken, onSuccess}) => {
  const [code, setCode]               = useState('');
  const [trustDevice, setTrustDevice] = useState(false);
  const [isLoading, setIsLoading]     = useState(false);
  const [error, setError]             = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.length !== 6 || isLoading) return;

    setIsLoading(true);
    setError('');

    const payload = JSON.stringify({
      dest:              'verifyMfaChallenge',
      userId,
      email,
      code,
      trustDevice:       trustDevice ? 1 : 0,
      deviceFingerprint: fingerprint || '',
      tempToken:         tempToken || null,
    });
    
    
    $.ajax({
      url:         `${ENDERECO_API}src/api/controller/twofactor.php`,
      type:        'POST',
      contentType: 'application/json',
      dataType:    'json',
      data:        payload,
      success: function (data) {
        
        if (data && data.status === 'valid') {
          onSuccess(trustDevice);
        } else {
          setError('Código inválido. Verifique e tente novamente.');
          setCode('');
          setIsLoading(false);
        }
      },
      error: function () {
        setError('Erro de conexão. Tente novamente.');
        setIsLoading(false);
      },
    });
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = '/auth/login';
  };

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: '#f0f2f5',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div style={{width: '100%', maxWidth: '420px', background: '#fff', borderRadius: '12px', padding: '40px 36px', boxShadow: '0 4px 24px rgba(0,0,0,0.10)'}}>
        <div className='text-center mb-4'>
          <div
            className='mx-auto mb-3 d-flex align-items-center justify-content-center'
            style={{
              width: '64px', height: '64px', borderRadius: '50%',
              background: 'linear-gradient(135deg, #2ed8b6 0%, #4099ff 100%)',
            }}
          >
            <i className='mdi mdi-shield-check text-white' style={{fontSize: '32px'}} />
          </div>
          <h5 className='font-weight-bold mb-1'>Verificação em Dois Fatores</h5>
          <p className='text-muted' style={{fontSize: '0.9rem'}}>
            Digite o código de 6 dígitos do seu aplicativo autenticador para continuar.
          </p>
        </div>

        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Control
              type='text'
              inputMode='numeric'
              pattern='[0-9]*'
              maxLength='6'
              placeholder='000000'
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              className='text-center'
              style={{fontSize: '2rem', letterSpacing: '0.6rem', fontFamily: 'monospace'}}
              autoFocus
              disabled={isLoading}
            />
          </Form.Group>

          {error && (
            <div className='alert alert-danger py-2 text-center' style={{fontSize: '0.85rem'}}>
              <i className='mdi mdi-alert-circle mr-1' />
              {error}
            </div>
          )}

          <Form.Group className='mb-4 d-flex align-items-center justify-content-center'>
            <Form.Check
              type='checkbox'
              id='trust-device-mfa'
              label='Confiar neste dispositivo por 7 dias'
              checked={trustDevice}
              onChange={(e) => setTrustDevice(e.target.checked)}
              disabled={isLoading}
            />
          </Form.Group>

          <Button variant='primary' type='submit' block disabled={code.length !== 6 || isLoading}>
            {isLoading ? (
              <><span className='spinner-border spinner-border-sm mr-2' />Validando...</>
            ) : (
              <><i className='mdi mdi-shield-check mr-2' />Validar</>
            )}
          </Button>
        </Form>

        <div className='text-center mt-3'>
          <Button variant='link' size='sm' onClick={handleLogout} disabled={isLoading} className='text-muted'>
            <i className='mdi mdi-logout mr-1' />
            Sair da conta
          </Button>
        </div>

        <div className='alert alert-info mt-3 py-2 text-center' style={{fontSize: '0.8rem'}}>
          <i className='mdi mdi-information-outline mr-1' />
          O código muda a cada 30 segundos.
        </div>
      </div>
    </div>
  );
};

export default MfaChallenge;
